
import { requests } from '.'
import { Filter } from '../commons/Types';
import ListData from '../models/List.model';
import Review from '../models/Review.model';


export const ReviewApi = {
  list: (filter: Filter) => requests.get<ListData<Review>>('v1/review', filter), 

  create: ({rating, description}: {rating: number, description: string}) => 
    requests.post<Review>('v1/review', {rating, description}),

  edit: (id: number, {rating, description}: {rating: number, description: string}) => 
    requests.patch<Review>(`v1/review/${id}`, {rating, description}),

  delete: (id: number) => 
    requests.delete<void>(`v1/review/${id}`),
  // one: (id: number) => requests.get<Notice>(`v1/notice/${id}`),
};